import { render, staticRenderFns } from "./apprList.vue?vue&type=template&id=3564c25a&scoped=true&"
import script from "./apprList.vue?vue&type=script&lang=js&"
export * from "./apprList.vue?vue&type=script&lang=js&"
import style0 from "./apprList.vue?vue&type=style&index=0&id=3564c25a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3564c25a",
  null
  
)

export default component.exports